// Deutsche Preisformatierung: . als Tausender-Trennzeichen, , als Cent-Trenner
export const formatPrice = (amount: number): string => {
  return new Intl.NumberFormat("de-DE", {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
};

// Formatierung für Beträge ohne Währungssymbol
export const formatAmount = (amount: number): string => {
  return new Intl.NumberFormat("de-DE", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
}; 